import React from "react";
import Styles from "./ReviewCard.module.scss";

interface ReviewCardProps {
  displayName: string;
  city?: string;
  sessionType?: string;
  reviewText: string;
  photoSrc?: string;
  sourceLabel?: string;
}

export const ReviewCard: React.FC<ReviewCardProps> = ({
  displayName,
  city,
  sessionType,
  reviewText,
  photoSrc,
  sourceLabel = "Shared directly",
}) => (
  <article className={Styles.card}>
    <span className={Styles.quoteMark} aria-hidden="true">
      “
    </span>
    <div className={Styles.content}>
      <blockquote className={`${Styles.quote} ${reviewText.length > 260 ? Styles.longQuote : ""}`}>
        {reviewText}
      </blockquote>
    </div>
    <footer className={Styles.signature}>
      <div className={Styles.authorDetails}>
        {photoSrc && (
          <img
            className={Styles.authorPhoto}
            src={photoSrc}
            alt=""
            loading="lazy"
            width={54}
            height={54}
            onError={(event) => {
              event.currentTarget.hidden = true;
            }}
          />
        )}
        <p className={Styles.name}>{displayName}</p>
      </div>
      <div className={Styles.metadata}>
        {(city || sessionType) && (
          <p className={Styles.context}>
            {city && <span className={Styles.location}>{city}</span>}
            {city && sessionType && (
              <span className={Styles.separator} aria-hidden="true">
                ·
              </span>
            )}
            {sessionType && <span className={Styles.session}>{sessionType} session</span>}
          </p>
        )}
        {sourceLabel && <p className={Styles.source}>{sourceLabel}</p>}
      </div>
    </footer>
  </article>
);
